import React, { useEffect, useState } from "react";
import {
  Grid,
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  Select,
  MenuItem,
  TextField,
  Card,
  CardContent,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { DataGrid } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import SaveIcon from "@mui/icons-material/Save";
import {
  WHPicking_Detail_GetRow_GETROW,
  WHPicking_Complete_GETROW,
  WHPicking_save_GETROW,
} from "../../Server/ApiV2";
import { vRdxUserInfo, WHPickingRo } from "../../Redux/roStore";
import {
  CmpButton,
  CmpSelectBox,
  CmpSelectField,
  CmpTextField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Detail_Set } from "./SliceWHPicking";
import Breadcrumbs from "./component/BreadCrumbs";
import { useNavigate } from "react-router-dom";

export default function WHPickingDetail() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vRdxHead = useSelector((state) => state.SliceWHPicking.value.Head);
  const DropId = useSelector((state) => state.SliceWHPicking.value.DropId);

  const [rows, setRows] = useState([]);
  const [isDropId, setIsDropID] = useState(false);

  const columns = [
    {
      field: "C_SrNo",
      headerName: "Serial No",
      width: 100,
    },
    {
      field: "C_ItmCd",
      headerName: "Item Code",
      width: 150,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 200,
    },
    {
      field: "C_PU_Unit",
      headerName: "Pack Unit",
      width: 150,
    },
    {
      field: "UnitName",
      headerName: "Unit Name",
      width: 150,
    },
    {
      field: "C_PU_PackQty",
      headerName: "Pack Quantity",
      width: 150,
    },
    {
      field: "PackDesc",
      headerName: "Pack Description",
      width: 200,
    },
    {
      field: "Barcode",
      headerName: "Barcode",
      width: 200,
    },
    {
      field: "C_PU_REQ_Qty",
      headerName: "Requested Quantity",
      width: 180,
    },
    {
      field: "C_PickStatus",
      headerName: "Pick Status",
      width: 150,
    },
    {
      field: "save",
      headerName: "Save",
      width: 100,
      renderCell: (params) => (
        <IconButton
          color="primary"
          onClick={() => Save(params.row)}
          disabled={params.row.C_PickStatus}
        >
          <SaveIcon />
        </IconButton>
      ),
    },
  ];

  const [xErrorMsgDetail, setXErrorMsgDetail] = useState({ B_Unit: "" });

  const handleUnitChange = (value, index) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, C_PickedUnit: value } : row
    );
    setRows(updatedRows);
  };

  const handleQtyChange = (value, index) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, C_PickedQty: value } : row
    );
    setRows(updatedRows);
  };
  const handleDropChange = (value, index) => {
   dispatch(Detail_Set(value)) 
  };
  const Complete = async () => {
    console.log(rows);
    
    const invalidRows = rows.filter(row => row.C_PickStatus == false);
    if (invalidRows.length > 0) {
      fAlertToast("FAILED", "Please ensure all items item is saved.");
      return 
    }else{
      const { Head } = WHPickingRo();
      const vRdxUserInfoObj = vRdxUserInfo();
      const payload = {
        VocTyp: Head.VocType,
        VocNo: Head.VocNo,
        UserCd: vRdxUserInfoObj.UserID,
      };
      let resp = await WHPicking_Complete_GETROW(
        fcheck_null_undefine_replace_empty(payload)
      );
      if (resp?.status === 200) {
        console.log(resp);
        fAlertToast("SUCCESS", "Successfully Completed");
        navigate("/WHPicking");
        handleLoad();
      } else {
        if (resp.response.status == 500) {
          fAlertToast("FAILED", resp.response.data.message.msg || "error  ");
        }
      }
    }
   
  };

  const Save = async (row) => {
    console.log(rows); 
    if(DropId  == "" || DropId == null || DropId == undefined){
      fAlertToast(
        "FAILED",
         "DropId should not be empty"
      );
    }else 
    //  if( row.C_PickedQty < 0){
    //   fAlertToast(
    //     "FAILED",
    //      "Picked quantity should not be Zero"
    //   );
    // }else
     if(row.C_PickedUnit == ""||row.C_PickedUnit == null||row.C_PickedUnit == undefined){
      fAlertToast(
        "FAILED",
         "Picked unit should not be empty"
      );
    }else{

      const { Head } = WHPickingRo();
      const { DropId } = WHPickingRo();
      const vRdxUserInfoObj = vRdxUserInfo();
      const payload = {
        VocTyp: Head.VocType,
        VocNo: Head.VocNo,
        SrNo: row.C_SrNo,
        PickedQty: row.C_PickedQty,
        PickedUnit: row.C_PickedUnit,
        UserCd: vRdxUserInfoObj.UserID,
        DropId: DropId,
      };
      let resp = await WHPicking_save_GETROW(
        fcheck_null_undefine_replace_empty(payload)
      );
      if (resp?.status === 200) {
        console.log(resp);
        fAlertToast("SUCCESS", "Successfully Save");
        handleLoad();
      } else {
        if (resp.response.status == 500) {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg || "error in  TransTermsUpdate "
          );
        }
      }
    }

  };

  const handleLoad = async () => {
    const { Head } = WHPickingRo();
    const payload = {
      VocTyp: Head?.VocType,
      VocNo: Head?.VocNo,
    };
    let resp = await WHPicking_Detail_GetRow_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      const loadedData =
        resp.data.ResultSet.length == 0
          ? []
          : resp.data.ResultSet.map((item, index) => ({
              ...item,
              id: index + 1,
            }));
      setRows(loadedData);
    } else {
      setRows([]);
      if (resp.response.status == 500) {
        fAlertToast("FAILED", resp.response.data.message.msg || "error  ");
      }
    }
  };
  useEffect(() => {
    handleLoad();
  }, []);
  useEffect(() => { 
   let onelineitemSave=rows.find(row => row.C_PickStatus === true)
   if (!!onelineitemSave) {
    setIsDropID(true)
   } 
  }, [rows]);
  

  return (
    <div className="container-fluid">
       <div className="mt-2">
       <Breadcrumbs />{" "}
       </div>
      <div className="row">
        <div className="col-sm-12 col-md-11 m-auto">
      
          <Grid container spacing={1} alignItems="center" marginY={"5px"}>
          
            <Grid item xs={12} sm={3} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Doc.No : {vRdxHead.VocNo}
                </Typography>
              </Box>
            </Grid>

       
            <Grid item xs={12} sm={3} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  DocName : {vRdxHead.VocName}
                </Typography>
              </Box>
            </Grid>

        
            <Grid item xs={6} sm={6} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Date : {moment(vRdxHead.A_VocDt).format("DD/MM/YYYY")}
                </Typography>
              </Box>
            </Grid>

   
            <Grid item xs={6} sm={6} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Location : {vRdxHead.LocName}
                </Typography>
              </Box>
            </Grid>

            
            <Grid item xs={12} sm={6} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  Status : {vRdxHead.Status}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={2} sm={1} md={0.8}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  DropID :
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={10} sm={6} md={5.2}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                   <TextField
                          type="text"
                          value={DropId}
                          onChange={(e) =>
                            handleDropChange(e.target.value)
                          }
                          //fullWidth
                          variant="outlined"
                          size="small"
                          InputProps={{ sx: { fontWeight: "bold" } }}
                        disabled={isDropId}
                        sx={{width:"65%"}}
                        />
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    fontSize: {
                      md: "15px !important",
                      sm: "14px !important",
                      xs: "12px",
                    },
                  }}
                >
                  ReqLoc : {vRdxHead.RequestLocName}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={1} marginY={"5px"} height={"75vh"} sx={{overflowY:"scroll",height:{md:"75vh",xs:"58vh"}}}>
            {rows.map((row, index) => (
              <Grid item xs={12} sm={6} md={6} key={row.id}>
                <Box
                  sx={{
                    border: 1,
                    borderColor: "primary.main",
                    borderRadius: "6px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    // height: "100%",  
                    padding:"10px"
                  }}
                >
                  <   >
                    <Grid container spacing={0.1} alignItems={"center"}>
                      {/* <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Sr.No:
                        </Typography>
                      </Grid> */}
                      {/* <Grid item xs={8} md={9} >
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {row.C_SrNo}
                        </Typography>
                     
                      </Grid> */}

                      {/* <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Item.Code:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={9}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.C_ItmCd}
                        </Typography>
                      </Grid> */}

                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Item.Name:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={9}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.ItmName}
                        </Typography>
                      </Grid>

                      {/* <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Pack.Qty:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={9}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.C_PU_PackQty}
                        </Typography>
                      </Grid> */}

                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Barcode:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={9} sx={{display: "flex", justifyContent:"space-between" ,alignItems:"center"}}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.Barcode}
                        </Typography>
                        <IconButton
                          color="primary"
                          onClick={() => Save(row)}
                          disabled={row.C_PickStatus}
                        >
                          {/* <SaveIcon /> */}
                          <CheckCircleIcon />
                        </IconButton>
                      </Grid>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Req.Qty:
                        </Typography>
                      </Grid>
                      <Grid item xs={3} md={1}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.C_PU_REQ_Qty}
                        </Typography>
                      </Grid>               

                      <Grid item xs={3} md={1.5}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Pk.Desc:
                        </Typography>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.PackDesc}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          UnitName:
                        </Typography>
                      </Grid>
                      <Grid item xs={8} md={1}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          {row.UnitName}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Picked.Qty:
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={3}
                        sx={{
                          fontWeight: "bold",
                          color: "primary.main",
                          fontSize: {
                            md: "15px !important",
                            sm: "14px !important",
                            xs: "12px",
                          },
                        }}
                      >
                        <TextField
                          type="number"
                          value={row.C_PickedQty}
                          onChange={(e) =>
                            handleQtyChange(e.target.value, index)
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputProps={{ sx: { fontWeight: "bold" } }}
                        />
                      </Grid>
                      <Grid item xs={4} md={3}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: {
                              md: "15px !important",
                              sm: "14px !important",
                              xs: "12px",
                            },
                          }}
                        >
                          Unit:
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        md={3}
                        sx={{
                          fontWeight: "bold",
                          color: "primary.main",
                          fontSize: {
                            md: "15px !important",
                            sm: "14px !important",
                            xs: "12px",
                          },
                        }}
                      >
                        <CmpSelectBox
                          xLabelText=""
                          xValue={row.C_PickedUnit}
                          xOnChange={(e) =>
                            handleUnitChange(e.target.value, index)
                          }
                          xName={"B_Unit"}
                          xData={row.UnitsArr}
                          xValueMember={"Name1"}
                          xDispalyMember={"Name1"}
                          xError={xErrorMsgDetail.B_Unit === "" ? false : true}
                          xErrorMessage={xErrorMsgDetail.B_Unit}
                          xDisable={false}
                          xsize="small"
                          sx={{ fontWeight: "bold" }}
                        />
                      </Grid>

                      {/* <Grid item xs={12} textAlign="end">
                        <IconButton
                          color="primary"
                          onClick={() => Save(row)}
                          disabled={row.C_PickStatus}
                        >
                          <SaveIcon />
                        </IconButton>
                      </Grid> */}
                    </Grid>
                  </ >
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid container justifyContent="flex-end">
            <CmpButton
              xbtnName="Complete"
              xOnClick={() => Complete()}
              xVariant="contained"
              xSize="small" 
              xDisabled={(vRdxHead?.Status)?.toUpperCase() == "POSTED"}
            />
          </Grid>
        </div>
      </div>
    </div>
  );
}
